import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useTimeout from '../../../../utils/use-timeout';

interface ISessionCountdownProps {
	timestamp: number | null;
}

const SessionCountdown: React.FC<ISessionCountdownProps> = ({ timestamp }) => {

	const [countdown, setCountdown] = useState('');
	const { t } = useTranslation("session");

	const dateCountdown = useCallback(() => {
		if (timestamp) {


			const date = new Date(timestamp);
			const now = new Date();
			const msBetween = date.valueOf() - now.valueOf();
			const day = 1000 * 60 * 60 * 24;
			const hour = 1000 * 60 * 60;
			const minute = 1000 * 60;
			const second = 1000;

			let specialString = '';

			if (msBetween > 0) {
				if (msBetween > day) {

					specialString = `${t("Live in")} ${Math.ceil(msBetween / day)} ${t("days")}`;
				} else if (msBetween > hour) {
					// round down here so we only have the hours, then round up on the minutes
					const hoursRemaining = Math.floor(msBetween / hour);

					specialString = `${t("Live in")} ${hoursRemaining} ${t("hours")} ${Math.ceil(msBetween / minute) - (hoursRemaining * 60)} ${t("minutes")}`;
				} else if (msBetween > minute) {

					specialString = `${t("Live in")} ${Math.ceil(msBetween / minute)} ${t("minutes")}`;
				} else {

					specialString = `${t("Live in")} ${Math.ceil(msBetween / second)} ${t("seconds")}`;
				}
			} else {
				if (msBetween < -day) {

					specialString = `${t("Live")} ${Math.ceil(msBetween / -day)} ${t("days ago")}`;
				} else if (msBetween < -hour) {

					specialString = `${t("Live")} ${Math.ceil(msBetween / -hour)} ${t("hours ago")}`;
				} else if (msBetween < -minute) {

					specialString = `${t("Live")} ${Math.ceil(msBetween / -minute)} ${t("minutes ago")}`;
				} else {

					specialString = `${t("Live")} ${Math.ceil(msBetween / -second)} ${t("seconds ago")}`;
				}
			}
			setCountdown(specialString);
		}
	}, [timestamp, t]);

	const { runWithTimeout } = useTimeout(() => {
		dateCountdown();
		runWithTimeout();
	}, 1000);

	const isEnd = useCallback(() => {
		if (timestamp) {
			const today = new Date();
			const date = new Date(timestamp!);
			const msBetween = date.valueOf() - today.valueOf();
			return msBetween <= 0;
		}
		return true;
	}, [timestamp]);

	useEffect(() => {
		dateCountdown();

		if (!isEnd()) {
			runWithTimeout();
		}
	}, [dateCountdown, isEnd, runWithTimeout, timestamp]);
	return <h3>{countdown}</h3>;
};

export default SessionCountdown;
